import { render, staticRenderFns } from "./ipce.vue?vue&type=template&id=3d59867c&scoped=true"
import script from "./ipce.vue?vue&type=script&lang=js"
export * from "./ipce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d59867c",
  null
  
)

export default component.exports